/**
 * Query key factory.
 *
 * Keys are built here so invalidation can be expressed at the right
 * granularity — `accountKeys.all` after a plan upgrade clears the identity the
 * whole chrome reads, without a component knowing the key shape.
 */
export const accountKeys = {
  all: ['account'] as const,
  me: () => [...accountKeys.all, 'me'] as const,
  profile: () => [...accountKeys.all, 'profile'] as const,
  preferences: () => [...accountKeys.all, 'preferences'] as const,
}
